import apiClient from './api';

/**
 * 文件上传接口，详见 doc/FILE_UPLOAD_API.md。
 *
 * POST /api/v2/files/upload，multipart/form-data，单文件字段名固定为 `file`。
 * 返回 { path, url }：
 *  - path：GCS 相对路径（对象 key），创建任务时填入 payload 的 img1/img2
 *  - url ：签名 URL，仅用于页面预览，有效期 10 分钟，不要用于建任务
 * 鉴权：API Key（X-API-Key），与创建任务接口一致。
 */
const UPLOAD_PATH = '/files/upload';

export interface UploadResult {
  /** GCS 相对路径，用于建任务 payload */
  path: string;
  /** 签名预览 URL，10 分钟有效，仅用于预览 */
  url: string;
}

export const uploadApi = {
  /**
   * 上传单个图片文件，返回 { path, url }。
   * @param file   图片文件
   * @param apiKey API 密钥（取自「系统设置 → API密钥」），作为 Authorization: Bearer 令牌
   */
  uploadImage: async (file: File, apiKey: string): Promise<UploadResult> => {
    const formData = new FormData();
    formData.append('file', file); // 字段名必须是 file

    // apiClient 响应拦截器返回的是响应体 { code, msg, data }
    const body: { code: number; msg?: string; data: UploadResult } = await apiClient.post(
      UPLOAD_PATH,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${apiKey}`,
        },
      }
    );

    if (body?.code !== 200 || !body?.data?.path) {
      throw new Error(body?.msg || '图片上传失败');
    }

    return body.data;
  },
};
